/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createStreamHook } from '../../core/factories/createStream.js';
import type { SubscribeProposalJobEventsVars, SubscribeProposalJobEventsEventName } from '../openapi-types.gen.js';

export type { SubscribeProposalJobEventsVars, SubscribeProposalJobEventsEventName } from '../openapi-types.gen.js';

export const useSubscribeProposalJobEventsSpec = {
  specName: 'useSubscribeProposalJobEvents',
  path: '/ai/proposal/jobs/events',
  events: new Set<SubscribeProposalJobEventsEventName>(['job.created', 'job.started', 'started', 'context', 'title.done', 'outcomes.done', 'description.done', 'imageQueries.done', 'cover.locked', 'cover.pinned', 'cover.pin_failed', 'cover.failed', 'outcome.locked', 'outcome.pinned', 'outcome.pin_failed', 'outcome.failed', 'create_ready', 'cancel_requested', 'cancelled', 'done', 'error']),
  buildBody: (vars: SubscribeProposalJobEventsVars) => ({ jobId: vars.jobId, afterSeq: vars.afterSeq }),
};

export const useSubscribeProposalJobEvents = createStreamHook<SubscribeProposalJobEventsVars, SubscribeProposalJobEventsEventName>(useSubscribeProposalJobEventsSpec);
